// extracted by mini-css-extract-plugin
export default {"LoresWrapper":"Lores_LoresWrapper__jNolo","LoresContainer":"Lores_LoresContainer__niBer","heads":"Lores_heads__ElXda"};